import { render, staticRenderFns } from "./DropdownFilterPortalRoles.vue?vue&type=template&id=70af3318&scoped=true&"
import script from "./DropdownFilterPortalRoles.vue?vue&type=script&lang=js&"
export * from "./DropdownFilterPortalRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af3318",
  null
  
)

export default component.exports